import { render, staticRenderFns } from "./alarmForPersonalLessee.vue?vue&type=template&id=5330bd68&scoped=true"
import script from "./alarmForPersonalLessee.vue?vue&type=script&lang=js"
export * from "./alarmForPersonalLessee.vue?vue&type=script&lang=js"
import style0 from "./alarmForPersonalLessee.vue?vue&type=style&index=0&id=5330bd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330bd68",
  null
  
)

export default component.exports